module.exports = __webpack_public_path__ + "img/ye.1efc742e.svg";